import { QUERY_KEYS } from '../../../../consts';
import { getTemplateInfoService } from '../../../../services';
import { getAtomWithMutation } from '../../../../utils';

export const getTemplateInfoAtom = getAtomWithMutation({
  mutationKey: QUERY_KEYS.DOCUMENTS.TEMPLATE_INFO,
  mutationFn: () => getTemplateInfoService,
});
